import type { Permissions } from '@efficiently/models';

import { PLATFORM_ADMIN_TAB_DEFINITIONS } from '@ds/shared/constants/platform-admin-tabs.constant';
import type { PlatformAdminTabDefinition } from '@ds/shared/models/platform-admin-tab-definition.model';

/**
 * The Platform Administrator sub-tabs this caller may both see and open, in strip order.
 *
 * Shared by the section's host, which draws the strip from it, and by the user-menu entry, which
 * derives its visibility (the list is non-empty) and its link (the first entry) from it. One
 * function, because the two must agree: an entry offering a section whose strip would be empty,
 * or linking to a page the route guard refuses, is the failure both gates exist to prevent.
 *
 * Both gates are required — see {@link PlatformAdminTabDefinition}.
 */
export function permittedPlatformAdminTabs(
	permissions: readonly Permissions[] | null | undefined,
): readonly PlatformAdminTabDefinition[] {
	const held = permissions ?? [];

	return PLATFORM_ADMIN_TAB_DEFINITIONS.filter(
		definition =>
			held.includes(definition.tabPermission) &&
			definition.routePermissions.every(permission => held.includes(permission)),
	);
}
